var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangleYellowSmall = function SvgAlertTriangleYellowSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.167 7.5a.834.834 0 0 1 1.667 0v3.333a.834.834 0 0 1-1.667 0V7.499Zm0 5.833a.834.834 0 1 1 1.667 0 .834.834 0 0 1-1.667 0Zm8.22 1.96c-.19.338-.562.54-.994.54H3.607c-.432 0-.804-.202-.994-.54a.81.81 0 0 1 .014-.847L9.02 3.848c.39-.645 1.57-.645 1.96 0l6.393 10.598c.222.367.104.69.014.848Zm1.414-1.708L12.408 2.986c-.5-.827-1.4-1.32-2.408-1.32s-1.908.493-2.407 1.32L1.2 13.586a2.478 2.478 0 0 0-.038 2.527c.482.855 1.42 1.386 2.445 1.386h12.786c1.026 0 1.963-.53 2.446-1.386a2.478 2.478 0 0 0-.038-2.528Z",
    fill: "#F3A800"
  })));
};
export default SvgAlertTriangleYellowSmall;